var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{staticStyle:{"object-fit":"fill"},style:(_vm.videoStyle),attrs:{"id":_vm.videoId,"controls":"","autoplay":"","autobuffer":"","muted":"","preload":"auto"},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }